module.exports = __webpack_public_path__ + "img/gsgg.fd0097ae.png";